import type { TemplateFormPdfInput } from "./templateFormPdf";
import { renderTemplateFormDocument } from "./renderTemplateFormDocument";

/** Long enough for the tab to have loaded the blob before it is freed. */
const REVOKE_AFTER_MS = 60_000;

function downloadPdf(url: string, filename: string) {
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  link.click();
}

/**
 * Renders the form as it prints and shows it. The tab is opened *before* the
 * render because a pop-up blocker judges `window.open` by the gesture it
 * follows, and an awaited render is no longer that gesture — where the tab is
 * blocked anyway, the document downloads instead of vanishing.
 */
export async function openTemplateFormPdf(
  input: TemplateFormPdfInput,
  filename: string
): Promise<{ notAppended: string[] }> {
  const tab = window.open("", "_blank");
  try {
    const rendered = await renderTemplateFormDocument(input);
    const url = URL.createObjectURL(new Blob([rendered.bytes], { type: "application/pdf" }));
    if (tab) tab.location.href = url;
    else downloadPdf(url, filename);
    window.setTimeout(() => URL.revokeObjectURL(url), REVOKE_AFTER_MS);
    return { notAppended: rendered.notAppended };
  } catch (error) {
    tab?.close();
    throw error;
  }
}
